import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-botao',
  standalone: true,
  imports: [],
  templateUrl: './botao.component.html',
  styleUrl: './botao.component.css'
})
export class ButtonComponent {
  @Input() label = '';
  @Input() icone?: string = './assets/icones/redesign/button/icon-add-button.svg';
  @Input() corFundo = 'var(--primary)';
  @Input() corTexto = '#FFFFFF';
  @Input() corBorda?: string;
  @Input() larguraBorda = '1px';
  @Input() largura = '168px';
  @Input() altura = '44px';
  @Input() pesoLabel = '600';
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' = 'button';

  @Output() aoClicar = new EventEmitter<void>();

  clicar() {
    if (!this.disabled) {
      this.aoClicar.emit();
    }
  }
}
